var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeinventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m142.9 0h136.9v445.7h-136.9z",
    fill: "#8192a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.8 334.3h51.1v111.4h-51.1z",
    fill: "#d4d7d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.8 334.3h45.7v111.4h-45.7z",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.8 110.4 99.7 40.3v295h-99.7z",
    fill: "#9facba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.5 294.3v151.4h-77v-107l53.4-30.8z",
    fill: "#8f9ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.8 110.4 10.3 4.1v331.2h-10.3z",
    fill: "#8f9ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 140.1 136.9-84.9v390.5h-136.9z",
    fill: "#9facba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.6 61.6 10.3-6.4v390.5h-10.3z",
    fill: "#8f9ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.9 68.6h29.1v29.1h-29.1zm-54.2 149.8h29.1v29.1h-29.1zm0-49.9h29.1v29.1h-29.1zm0-50h29.1v29.1h-29.1zm0-49.9h29.1v29.1h-29.1zm54.2 149.8h29.1v29.1h-29.1zm0-49.9h29.1v29.1h-29.1zm0-50h29.1v29.1h-29.1z",
    fill: "#c2d4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.9 68.6h24.1v29.1h-24.1zm24.1 178.8v-29.1h-24.1v29.1zm0-49.9v-29.1h-24.1v29.1zm0-49.9v-29.1h-24.1v29.1zm-78.3 70.8h29.1v29.1h-29.1zm0-49.9h29.1v29.1h-29.1zm0-50h29.1v29.1h-29.1zm0-49.9h29.1v29.1h-29.1z",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.8 262.8h29.1v29.1h-29.1zm54.2-99.8h29.1v29.1h-29.1zm-54.2 0h29.1v29.1h-29.1zm54.2 49.9h29.1v29.1h-29.1zm-54.2 0h29.1v29.1h-29.1zm54.2 49.9h29.1v29.1h-29.1z",
    fill: "#c2d4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.8 262.8h29.1v29.1h-29.1zm77.2 29.1v-29.1h-23v29.1zm0-49.9v-29.1h-23v29.1zm0-49.9v-29.1h-23v29.1zm-77.2-29.1h29.1v29.1h-29.1zm0 49.9h29.1v29.1h-29.1z",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.1 163h29.1v29.1h-29.1zm0 99.8h29.1v29.1h-29.1zm0-49.9h29.1v29.1h-29.1z",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.4 163h4.8v29.1h-4.8zm0 128.9v-29.1h4.8v29.1zm0-49.9v-29.1h4.8v29.1z",
    fill: "#c2d4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.4 288.9 48.3 27.9 48.3 27.9v55.8 55.7l-48.3 27.9-48.3 27.9-48.3-27.9-48.3-27.9v-55.7-55.8l48.3-27.9z",
    fill: "#f2d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.4 288.9 48.3 27.9 48.3 27.9-96.6 55.8-96.6-55.8 48.3-27.9z",
    fill: "#e3a76f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506 344.7v55.8 55.7l-48.3 27.9-48.3 27.9v-111.5z",
    fill: "#ecba78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.9 322.7-94.8 57v23.6l-25.2-13.1v-25.1l97.9-55.2z",
    fill: "#e3a76f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.9 322.7-94.7 56.9-25.1-14.6 97.7-55.1z",
    fill: "#b8875a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeinventory);
export default __webpack_public_path__ + "static/media/Office inventory.9802a13e13bf353f9e1ba8c474745616.svg";
export { ForwardRef as ReactComponent };